import { buildLexer } from "typescript-parsec";
export var TokenKind;
(function (TokenKind) {
    TokenKind[TokenKind["KeywordTrue"] = 0] = "KeywordTrue";
    TokenKind[TokenKind["KeywordFalse"] = 1] = "KeywordFalse";
    TokenKind[TokenKind["KeywordUndefined"] = 2] = "KeywordUndefined";
    TokenKind[TokenKind["KeywordNull"] = 3] = "KeywordNull";
    TokenKind[TokenKind["Identifier"] = 4] = "Identifier";
    TokenKind[TokenKind["$Identifier"] = 5] = "$Identifier";
    TokenKind[TokenKind["StringLiteral"] = 6] = "StringLiteral";
    TokenKind[TokenKind["NumberLiteral"] = 7] = "NumberLiteral";
    TokenKind[TokenKind["EQ"] = 8] = "EQ";
    TokenKind[TokenKind["LT"] = 9] = "LT";
    TokenKind[TokenKind["GT"] = 10] = "GT";
    TokenKind[TokenKind["Max"] = 11] = "Max";
    TokenKind[TokenKind["Min"] = 12] = "Min";
    TokenKind[TokenKind["Contains"] = 13] = "Contains";
    TokenKind[TokenKind["Add"] = 14] = "Add";
    TokenKind[TokenKind["Substract"] = 15] = "Substract";
    TokenKind[TokenKind["Mul"] = 16] = "Mul";
    TokenKind[TokenKind["Div"] = 17] = "Div";
    TokenKind[TokenKind["And"] = 18] = "And";
    TokenKind[TokenKind["Or"] = 19] = "Or";
    TokenKind[TokenKind["Not"] = 20] = "Not";
    TokenKind[TokenKind["Get"] = 21] = "Get";
    TokenKind[TokenKind["FormatDate"] = 22] = "FormatDate";
    TokenKind[TokenKind["FormatToTimestamp"] = 23] = "FormatToTimestamp";
    TokenKind[TokenKind["Dot"] = 24] = "Dot";
    TokenKind[TokenKind["Colon"] = 25] = "Colon";
    TokenKind[TokenKind["QuestionMark"] = 26] = "QuestionMark";
    TokenKind[TokenKind["OpenBrace"] = 27] = "OpenBrace";
    TokenKind[TokenKind["CloseBrace"] = 28] = "CloseBrace";
    TokenKind[TokenKind["OpenParen"] = 29] = "OpenParen";
    TokenKind[TokenKind["CloseParen"] = 30] = "CloseParen";
    TokenKind[TokenKind["OpenSquare"] = 31] = "OpenSquare";
    TokenKind[TokenKind["CloseSquare"] = 32] = "CloseSquare";
    TokenKind[TokenKind["Comma"] = 33] = "Comma";
    TokenKind[TokenKind["Values"] = 34] = "Values";
    TokenKind[TokenKind["Space"] = 35] = "Space";
})(TokenKind || (TokenKind = {}));
export var tokenizer = buildLexer([
    [true, /^false/g, TokenKind.KeywordFalse],
    [true, /^true/g, TokenKind.KeywordTrue],
    [true, /^undefined/g, TokenKind.KeywordUndefined],
    [true, /^null/g, TokenKind.KeywordNull],
    [true, /^NaN/g, TokenKind.NumberLiteral],
    [true, /^[+-]?\d+(\.\d+)?/g, TokenKind.NumberLiteral],
    [true, /^'([^']|\\.)*'/g, TokenKind.StringLiteral],
    [true, /^values/g, TokenKind.Values],
    [true, /^and/g, TokenKind.And],
    [true, /^or/g, TokenKind.Or],
    [true, /^not/g, TokenKind.Not],
    [true, /^get/g, TokenKind.Get],
    [true, /^eq/g, TokenKind.EQ],
    [true, /^gt/g, TokenKind.GT],
    [true, /^lt/g, TokenKind.LT],
    [true, /^max/g, TokenKind.Max],
    [true, /^min/g, TokenKind.Min],
    [true, /^contains/g, TokenKind.Contains],
    [true, /^add/g, TokenKind.Add],
    [true, /^substract/g, TokenKind.Substract],
    [true, /^mul/g, TokenKind.Mul],
    [true, /^div/g, TokenKind.Div],
    [true, /^formatDate/g, TokenKind.FormatDate],
    [true, /^formatToTimestamp/g, TokenKind.FormatToTimestamp],
    // Identifier 必须放在下面，否则会把上面的字符解析为 Identifier
    [true, /^[a-zA-Z_][a-zA-Z0-9_]*/g, TokenKind.Identifier],
    [true, /^\$[a-zA-Z_][a-zA-Z0-9_]*/g, TokenKind.$Identifier],
    [true, /^\./g, TokenKind.Dot],
    [true, /^\{/g, TokenKind.OpenBrace],
    [true, /^\}/g, TokenKind.CloseBrace],
    [true, /^\(/g, TokenKind.OpenParen],
    [true, /^\)/g, TokenKind.CloseParen],
    [true, /^\[/g, TokenKind.OpenSquare],
    [true, /^\]/g, TokenKind.CloseSquare],
    [true, /^:/g, TokenKind.Colon],
    [true, /^\?/g, TokenKind.QuestionMark],
    [true, /^,/g, TokenKind.Comma],
    [false, /^\s+/g, TokenKind.Space],
]);
